<template>
  <Modal v-model="modalValue" title="导入" class="import-grant" width="800" footer-hide>
    <Spin size="large" fix v-if="diyDom.spinShow"></Spin>
    <div class="content">
      <div class="step" style="margin-bottom: 60px">
        <Steps :current="step">
          <Step title="选择证书" content="请先选择用户证书类型"></Step>
          <Step title="下载模板" content="如已下载可直接下一步"></Step>
          <Step title="导入文件" content="请选择需要导入的文件"></Step>
          <Step title="导入免冠照" content="请选择需要导入的免冠照"></Step>
        </Steps>
      </div>
      <div v-show="step == 0">
        <div>
          <span>证书：</span>
          <Select transfer placeholder="请选择证书" v-model="diyData.certificates_id" filterable style="width: 240px">
            <Option
              v-for="(item, index) in apiData.tableList"
              :key="index"
              :label="item.title"
              :value="item.id"
            ></Option>
          </Select>
          <a style="display: block; margin-top: 10px" @click="step = 3">直接导入免冠照</a>
        </div>
      </div>
      <div v-show="step == 1">
        <Button icon="ios-download" @click="importPanel">点击下载模板</Button>
      </div>

      <div v-show="step == 2">
        <Upload
          :action="uploadUrl"
          :headers="token"
          :on-error="uploadErr"
          :on-success="uploadSuccess"
          :before-upload="beforeUpload"
          name="file"
          :show-upload-list="false"
          ref="upload"
        >
          <Button class="upload-btn" style="width: 240px; font-size: 12px">
            请选择需要导入的文件
            <Icon type="ios-expand" style="icon" />
          </Button>
        </Upload>
      </div>

      <div v-show="step == 3">
        <div class="photo-content">
          <p style="color: #ed4014">*免冠照请使用身份证命名，否则无法匹配证书</p>
          <Upload
            :action="uploadPhotoUrl"
            :headers="token"
            :on-error="uploadErr"
            :on-success="uploadSuccess"
            :before-upload="beforeUpload"
            name="file"
            :show-upload-list="false"
            ref="upload"
          >
            <Button class="upload-btn" style="width: 240px; font-size: 12px">
              请选择需要导入的文件
              <Icon type="ios-expand" style="icon" />
            </Button>
          </Upload>
          <div class="download">*注：仅支持zip格式的文件上传</div>
        </div>
      </div>

      <div class="btns">
        <Button v-show="step != 0" @click="lastStep">上一步</Button>
        <Button v-show="step != 3" @click="nextStep" type="primary" style="margin-left: 30px">下一步</Button>
      </div>
    </div>
  </Modal>
</template>

<script>
  import * as apiCertificates from '@/api/certificates'
  import downloadBlob from '@/utils/downloadBlob'
  export default {
    name: 'import',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        // query参数
        query: {},
        // 搜索参数
        search: {},
        // DOM操作
        diyDom: {
          btnDisabled: true,
          spinShow: false,
        },
        // 自定义数据
        diyData: {
          certificates_id: '',
        },
        step: 0,
        // 接口请求数据
        apiData: {
          tableList: [],
        },
      }
    },
    methods: {
      // 获取证书列表

      getLicense() {
        apiCertificates.apiCertificatesList().then(res => {
          const { data } = res
          this.apiData.tableList = data
        })
      },
      // 上一步
      lastStep() {
        this.step = this.step - 1
      },
      // 下一步
      nextStep() {
        if (this.step == 0 && !this.diyData.certificates_id) return this.$Message.error('请选择证书')
        this.step = this.step + 1
      },

      importPanel() {
        if (!this.diyData.certificates_id) return this.$Message.error('请选择证书')
        if(this.diyData.certificates_id === undefined) this.diyData.certificates_id = ''
        apiCertificates
          .apiCertificatesUsersDownload(this.diyData.certificates_id, {
            t: new Date().getTime(),
          })
          .then(res => {
            downloadBlob(res)
          })
      },
      // 上传之前开启加载效果
      beforeUpload() {
        this.diyDom.spinShow = true
      },
      uploadSuccess(e) {
        this.diyDom.spinShow = false
        if (e.code == 0) {
          if (e.data.error_url) {
            this.$Modal.info({
              title: '提示',
              content: e.message,
              okText: '下载错误原因',
              onOk: () => {
                let a = document.createElement('a')
                a.href = e.data.error_url
                a.target = '_blank'
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
              },
            })
          } else {
            this.$Message.success('导入成功')
            if (this.step == 2) {
              return (this.step = 3)
            }
            this.$emit('on-success', this.step)
            this.modalValue = false
          }
        } else {
          this.$Modal.error({
            title: '提示',
            content: e.message,
          })
        }
      },
      uploadErr() {
        this.diyDom.spinShow = false
        this.$Modal.error({
          title: '提示',
          content: '文件上传失败，请重试',
        })
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
      uploadUrl() {
        return process.env.VUE_APP_API_URL + `/admin/certificates/users/import/${this.diyData.certificates_id}`
      },
      uploadPhotoUrl() {
        return process.env.VUE_APP_API_URL + '/admin/certificates/users/import-licence-photo'
      },
    },
    watch: {
      value(val) {
        if (val) {
          this.getLicense()
        } else {
          this.step = 0
          this.diyData.certificates_id = ''
        }
      },
    },
  }
</script>

<style scoped lang="less">
  .content {
    text-align: center;
    padding: 10px 0 50px 0;
    .download {
      margin-top: 40px;
      cursor: pointer;
      padding-bottom: 40px;
      color: #2d8cf0;
    }
    .upload-btn {
      position: relative;
      .ivu-icon {
        position: absolute;
        right: 5px;
        top: 10px;
      }
    }
  }
  .btns {
    width: 200px;
    display: flex;
    justify-content: space-around;
    margin: 50px auto 0;
  }
  .photo-content {
    text-align: center;
    p {
      margin: 20px auto 40px;
    }
    .download {
      margin-top: 40px;
      cursor: pointer;
    }
    .upload-btn {
      position: relative;
      .ivu-icon {
        position: absolute;
        right: 5px;
        top: 10px;
      }
    }
  }
</style>
